import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ReceiptPhotoIntroProps {
  onStartCamera: () => void;
}

export default function ReceiptPhotoIntro({ onStartCamera }: ReceiptPhotoIntroProps) {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Receipt photos</h1>
          <p className="text-muted-foreground text-base">
            You can add up to 10 photos in order to capture the entire length of the receipt.
          </p>
        </div>
        
        <Button 
          onClick={onStartCamera}
          size="lg"
          className="w-full h-14 text-lg font-semibold bg-[#22c25c] hover:bg-[#1ea550] text-white"
        >
          <Camera className="mr-2 h-6 w-6" />
          Take photos
        </Button>
      </div>
    </div>
  );
}
